// extracted by mini-css-extract-plugin
export var container = "styles-module__container___ICWim";
export var title = "styles-module__title___g86hO";
export var fader = "styles-module__fader___x1v_Y";
export var tabBar = "styles-module__tabBar___IDbPr";